import { render, staticRenderFns } from "./ViewApprovals.vue?vue&type=template&id=de3d7270"
import script from "./ViewApprovals.vue?vue&type=script&lang=js"
export * from "./ViewApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports